export default __webpack_public_path__ + "static/media/p13.33adf64c.jpg";